import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AsyncReduxState, initialAsyncReduxState } from '../../defaults';

export type ResetPasswordState = AsyncReduxState<{
    hasRequestedSuccessfully: boolean;
    hasChangedSuccessfully: boolean;
}>;

const initialState: ResetPasswordState = {
    ...initialAsyncReduxState,
    hasRequestedSuccessfully: false,
    hasChangedSuccessfully: false,
};

const resetPasswordSlice = createSlice({
    name: 'resetPasswordSlice',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): ResetPasswordState {
            return {
                ...state,
                isLoading: action.payload,
            };
        },
        setHasRequestedSuccessfully(state, action: PayloadAction<boolean>): ResetPasswordState {
            return {
                ...state,
                hasRequestedSuccessfully: action.payload,
            };
        },
        setHasChangedSuccessfully(state, action: PayloadAction<boolean>): ResetPasswordState {
            return {
                ...state,
                hasChangedSuccessfully: action.payload,
            };
        },
        setError(state, action: PayloadAction<string>): ResetPasswordState {
            return {
                ...state,
                error: action.payload,
            };
        },
    },
});

export const {
    setIsLoading,
    setHasRequestedSuccessfully,
    setHasChangedSuccessfully,
    setError,
} = resetPasswordSlice.actions;

export default resetPasswordSlice;
